/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react'

import {
  Button,
  Col,
  Form,
  Input,
  PageHeader,
  Radio,
  Row,
  Skeleton,
  Spin,
} from 'antd'
import { MaskedInput } from 'antd-mask-input'
import DateSelector from 'Components/Form/DateSelector'
import PesquisaVeiculo from 'Components/Form/PesquisaVeiculo'
import { SelectFieldAnt, SelectItemProps } from 'Components/Form/Select'
import ID_COMPONENTE from 'config/idComponente'
import { ApplicationContext } from 'Context'
import Veiculos from 'Helpers/Veiculos'
import cnpj from 'Hooks/useMask/cnpj'
import cpf from 'Hooks/useMask/cpf'
import { Empresa, Motorista, Veiculo } from 'Models/cadastros'
import { ICandidato } from 'Models/docas'
import moment from 'moment'
import env from 'react-dotenv'
import { useForm } from 'react-hook-form'
import { useSnackbar } from 'react-simple-snackbar'
import { ParamsRequest } from 'Services/__shared/types/resquest'
import WsCadastroService from 'Services/WS_CADASTRO'
import WsDocasService from 'Services/WS_DOCAS'
import { MsgSuccessOptions } from 'Types/SnackbarTypes'
import IFormEmpresasFilter from 'Views/Cadastros/Empresas/IFormEmpresasFilter'
import IFormMotoristasFilter from 'Views/Cadastros/Motoristas/IFormMotoristasFilter'
import IFormVeiculosFilter from 'Views/Cadastros/Veiculos/IFormVeiculosFilter'

import { DocasContext } from '../Context/context'

interface IProps {
  setModal: Dispatch<SetStateAction<boolean>>
  updateGridCandidatos: () => void
}

const ModalCandidatos = ({ setModal, updateGridCandidatos }: IProps) => {
  const hookForm = useForm()
  const [form] = Form.useForm()
  const { docasContext, setDocasContext } = useContext(DocasContext)
  const { applicationContext, setApplicationContext } =
    useContext(ApplicationContext)
  const [carregandoInclusao, setCarregandoInclusao] = useState<boolean>(false)
  const [selectMotoristaItens, setSelectMotoristaItens] = useState<
    SelectItemProps[]
  >([])
  const [motoristas, setMotoristas] = useState<Motorista[]>([])
  const [carregandoMotoristas, setCarregandoMotoristas] =
    useState<boolean>(true)

  const [veiculoSelecionado, setVeiculoSelecionado] = useState<Veiculo>()
  const [transportadoraSelecionada, setTransportadoraSelecionada] =
    useState<Empresa>()

  const [mostrarFormulario, setMostrarFormulario] = useState<boolean>(true)

  const [podeCriarCandidatosSemMotorista] = useState<boolean>(
    env.CDS_ENTIDADES_SISTEMA_PODEM_CRIAR_CANDIDATOS_SEM_MOTORISTA.split(',')
      .map((cdEntidadeSistema: string) => window.parseInt(cdEntidadeSistema))
      .includes(applicationContext.usuarioAtual?.cdEntidadeSistema),
  )

  const [openSnackbarSuccess, closeSnackbarSuccess] =
    useSnackbar(MsgSuccessOptions)

  const getMotoristas = async () => {
    setCarregandoMotoristas(true)

    const filtros: IFormMotoristasFilter = {
      ativo: true,
    }

    const parametros: ParamsRequest = {
      pageSize: 100,
      pageNumber: 1,
    }

    const { data } = await WsCadastroService.motoristas.getList(
      ID_COMPONENTE.DOCAS,
      filtros,
      parametros,
    )

    if (data.items) {
      setMotoristas(data.items)

      const selectMotoristasData: SelectItemProps[] = data.items.map(
        (item: Motorista) => {
          return {
            value: item.id.toString(),
            label: item.nome + (item.sobrenome ? ' ' + item.sobrenome : ''),
          }
        },
      )

      setSelectMotoristaItens(selectMotoristasData)
    }

    if (mostrarFormulario && (!data.items || data.items.length === 0)) {
      setMostrarFormulario(false)
    }

    setCarregandoMotoristas(false)
  }

  useEffect(() => {
    getMotoristas()
  }, [])

  const monstraMensagemErroFormulario = () => {
    let mensagemErro =
      'Antes de continuar, acesse a tela inicial do Compulog e cadastre pelo menos um(a)'

    if (selectMotoristaItens.length === 0) {
      mensagemErro += ' motorista,'
    }

    mensagemErro = mensagemErro.substring(0, mensagemErro.length - 1) + '.' //Remove a ultima virgula e coloca um ponto final

    return (
      <>
        <Row>
          <Col span={24}>
            <div style={{ textAlign: 'center', fontSize: '20px' }}>
              <div>ATENÇÃO!</div>
              <div>{mensagemErro}</div>
            </div>
          </Col>
        </Row>
      </>
    )
  }

  const cadastraCandidato = async (candidato: ICandidato) => {
    setCarregandoInclusao(true)

    candidato.previsaoCargaDescarga =
      candidato.previsaoCargaDescargaMoment!.format()

    if (docasContext.armazemAtual) {
      candidato.armazem = docasContext.armazemAtual.nomeArmazem

      candidato.cdAgendamentoDocasArmazem =
        docasContext.armazemAtual.cdAgendamentoDocasArmazem

      candidato.cdPontoEntidadeArmazem =
        docasContext.armazemAtual.cdPontoEntidadeArmazem

      candidato.cdPontoEntidadeUnidade =
        docasContext.armazemAtual.cdPontoEntidadeUnidade
    }

    candidato.agendado = false
    candidato.ativo = true
    candidato.criaViagem = true

    let motorista: Motorista | undefined

    if (candidato.cdMotorista) {
      motorista = motoristas.find((f) => f.id == candidato.cdMotorista)

      if (motorista) {
        candidato.nome = motorista.nome
        candidato.sobrenome = motorista.sobrenome ?? ''
        candidato.cpf = motorista.cpf
      }
    }

    const cnpjString: string | undefined = transportadoraSelecionada?.cnpj

    if (cnpjString) {
      candidato.cnpj = parseInt(cnpj.clean(cnpjString).toString())
    }

    const placa: string | undefined = veiculoSelecionado?.placa

    if (placa) {
      candidato.placa = placa
    }

    candidato.nomeTransportadora = transportadoraSelecionada?.nome ?? ''

    const { data } = await WsDocasService.candidatos.create(
      ID_COMPONENTE.DOCAS,
      candidato,
    )

    if (data?.statusCode === 501) {
      setModal(false)
      openSnackbarSuccess('Candidato cadastrado com sucesso')
      await updateGridCandidatos()
    }

    setCarregandoInclusao(false)
  }

  return (
    <Form onFinish={cadastraCandidato} layout="vertical" form={form}>
      <PageHeader
        ghost={false}
        title="Cadastrar Candidato"
        extra={
          mostrarFormulario
            ? [
                <Button
                  key="cadastraCandidato"
                  type="primary"
                  htmlType="submit"
                  disabled={!veiculoSelecionado}
                >
                  Cadastrar
                </Button>,
              ]
            : []
        }
      >
        {mostrarFormulario ? (
          <>
            <Row gutter={16}>
              <Col span={8}>
                {carregandoMotoristas ? (
                  <Form.Item
                    label="Motorista:"
                    name="cdMotorista"
                    rules={[{ required: true, message: 'Campo obrigatório' }]}
                  >
                    <Spin />
                  </Form.Item>
                ) : podeCriarCandidatosSemMotorista ? (
                  <SelectFieldAnt
                    methods={hookForm}
                    scope="form-candidato"
                    label="Motorista:"
                    name="cdMotorista"
                    items={selectMotoristaItens}
                    showSearch={true}
                  />
                ) : (
                  <SelectFieldAnt
                    methods={hookForm}
                    scope="form-candidato"
                    label="Motorista:"
                    name="cdMotorista"
                    items={selectMotoristaItens}
                    showSearch={true}
                    rules={[{ required: true, message: 'Campo obrigatório' }]}
                  />
                )}
              </Col>

              <Col span={16}>
                <PesquisaVeiculo
                  form={form}
                  setVeiculoSelecionado={setVeiculoSelecionado}
                  veiculoSelecionado={veiculoSelecionado}
                  obrigatorioSelecionarTransportadora={true}
                  setTransportadoraSelecionada={setTransportadoraSelecionada}
                  transportadoraSelecionada={transportadoraSelecionada}
                  rules={[{ required: true, message: 'Campo obrigatório' }]}
                />
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={8}>
                <DateSelector
                  name="previsaoCargaDescargaMoment"
                  label="Previsão para Carga/Descarga:"
                  initialValue={moment()}
                  showTime={true}
                  rules={[{ required: true, message: 'Campo obrigatório' }]}
                />
              </Col>

              <Col span={8}>
                <Form.Item
                  name="tipo"
                  label="Tipo:"
                  rules={[{ required: true, message: 'Campo obrigatório' }]}
                  initialValue={1}
                >
                  <Radio.Group>
                    <Radio value={1}>Carga</Radio>
                    <Radio value={2}>Descarga</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
          </>
        ) : (
          monstraMensagemErroFormulario()
        )}
      </PageHeader>
    </Form>
  )
}

export default ModalCandidatos
